module.exports = __webpack_public_path__ + "img/template_pet_id_card.c2e5857d.png";